import React, { Component } from 'react'

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

export default class Footer extends Component {
    render() {
        return (
            <section className='footer'>
                &copy; { currentYear } Web Design &amp; Hosting By <a href='https://www.matthewcramer.net'>Matthew Cramer</a>
            </section>
        );
    }
}